import styled from "@emotion/styled";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
  align-items: center;
  flex-direction: column;
  align-items:initial;
`;

export const AddTitle = styled.h2`
  font-size: 30px;
  font-weight: bold;
  line-height: 1.23;
  letter-spacing: -0.72px;
  color: #011627;
`;

export const FlexDisplay = styled.div`
display: flex;
flex-direction: row;
justify-content: end;

`